import './BlockNavWithUnsavedChangesModal.css'
import {
  Button,
  Col,
  Row,
  Typography,
  Modal,
} from "antd";
import React, { useState } from 'react';
import { Prompt, useHistory } from "react-router-dom";

/**
 * A modal component that prompts users when they attempt to navigate away
 * with unsaved changes
 */
const BlockNavWithUnsavedChangesModal = ({
  hasUnsavedChanges = false,
  title = 'Are you sure you want to leave?',
  message = 'You have unsaved changes on this page. Leaving this page without saving may result in your changes being lost.',
  beforeStay = () => { },
  afterStay = () => { },
  beforeConfirm = () => { },
  afterConfirm = () => { },
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);

  const history = useHistory();

  const onStayClick = () => {
    beforeStay();

    setIsModalOpen(false);

    afterStay();
  };

  const onConfirmClick = () => {
    if (nextLocation == null) {
      console.error("nextLocation is null");
      setIsModalOpen(false);
      return;
    }

    beforeConfirm();

    setIsModalOpen(false);
    history.push(nextLocation);

    afterConfirm();
  };

  const onAttemptToLeavePage = (nextLocation) => {
    const location = history.location;

    // "Leave Anyway"
    // If this is second attempt to leave the page or changes have been saved, let them
    if (isModalOpen || !hasUnsavedChanges) {
      return true;
    }

    // If navigating to the same page: dont show modal, let them, no changes lost
    if (location.pathname === nextLocation.pathname) {
      return false;
    }

    // Show modal, 
    setIsModalOpen(true);
    setNextLocation(nextLocation.pathname);
    return false;

  };

  return (
    <div className="block-nav-with-unsaved-changes-modal">
      <Prompt message={onAttemptToLeavePage} when={hasUnsavedChanges} />
      <Modal
        className="prevent-nav-modal"
        open={isModalOpen}
        closable={false}
        footer={[
          <Button
            className="standard-button secondary-orange-button"
            key="confirm"
            onClick={onConfirmClick}
          >
            Leave Anyway
          </Button>,
          <Button
            className="standard-button primary-orange-button"
            key="stay"
            type="primary"
            onClick={onStayClick}
          >
            Stay
          </Button>,
        ]}
      >
        <Row>
          <Col span={24}>
            <Typography.Title level={5}>
              {title}
            </Typography.Title>
            <Typography.Text type="secondary">
              {message}
            </Typography.Text>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default BlockNavWithUnsavedChangesModal;